import $ from 'jquery';

class HeroHeader {
   constructor() {
      this.heroHeader = $('.hero-header');
      this.init();
   }

   init() {
      if (this.heroHeader.length) {
         this.heroHeader.each((index, element) => {
            const words = $(element).html().trim().split(' ');
            if (words.length > 2) {
               const lastTwoWords = words.slice(-2).join(' ');
               const firstWords = words.slice(0, -2).join(' ');
               $(element).html(`${firstWords} <span class="highlight">${lastTwoWords}</span>`);
            }
         });
      }
   }
}

export default HeroHeader;